<template>
  <div v-if="!modal" class="flex h-12 items-center justify-between border-b border-gray-800 px-6">
    <div class="text-sm font-medium text-gray-100">{{ webhook?.id ? `Edit` : 'Create' }} Destination Settings</div>
  </div>
  <div class="space-y-2 py-4" style="height: calc(100% - 65px)">
    <div class="px-6">
      <BaseRadio v-if="!webhook?.id" :options="channels" v-model="selectedChannel" />
    </div>
    <div class="h-full overflow-y-auto">
      <AlertsDeliveryDiscordInstructions v-if="selectedChannel == 'Discord'" />
      <AlertsDeliveryTelegramInstructions v-else-if="selectedChannel == 'Telegram'" />
      <AlertsDeliverySlackInstructions v-else-if="selectedChannel == 'Slack'" />
      <AlertsDeliveryMobileTab v-else-if="selectedChannel == 'Mobile'" />
      <AlertsDeliveryForm v-if="selectedChannel != 'Mobile'" v-model="currentWebhook" :edit="!!webhook?.id" />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, inject } from 'vue';
import AlertsDeliveryMobileTab from '@/components/alerts/delivery/AlertsDeliveryMobileTab.vue';
import AlertsDeliveryForm from './AlertsDeliveryForm.vue';
import AlertsDeliveryDiscordInstructions from './AlertsDeliveryDiscordInstructions.vue';
import AlertsDeliveryTelegramInstructions from './AlertsDeliveryTelegramInstructions.vue';
import AlertsDeliverySlackInstructions from './AlertsDeliverySlackInstructions.vue';
import { titleize } from '@/composeables/filters';

const props = defineProps({
  webhook: { type: Object, default: null },
  modal: { type: Boolean, default: false }
});

//CURRENT WEBHOOK
const currentWebhook = ref({
  name: '',
  link: '',
  status: '',
  channel: 'email',
  id: 0,
  mode: 'news'
});
watch(
  () => currentWebhook.value,
  () => {
    if (currentWebhook.value) {
      currentWebhook.value.status = 'verified';
      selectedChannel.value = titleize(currentWebhook.value.channel);
    }
  }
);

watch(
  () => props.webhook,
  val => {
    if (val) currentWebhook.value = { ...currentWebhook, ...val };
  },
  { deep: true, immediate: true }
);

//CHANNELS
const channels = ['Email', 'Discord', 'Telegram', 'Slack', 'Webhook', 'Mobile'];
const selectedChannel = ref('Email');
watch(
  () => selectedChannel.value,
  () => {
    currentWebhook.value.channel = selectedChannel.value.toLowerCase();
  }
);

//MOBILE SETUP
const forceMobileSetup = inject('force-mobile-setup');
watch(forceMobileSetup, () => {
  if (forceMobileSetup.value) selectedChannel.value = 'Mobile';
});
</script>
